// Toasts

import type { ToastType } from '@/types';
import { toast } from 'vue3-toastify';

import WToast from '@/components/elements/WToast/WToast.vue';

interface ToastAttributes {
  message: string;
  type: ToastType;
  id?: string | number;
}

export function showToast({ id, message, type }: ToastAttributes) {
  if (!id) {
    // if ID is undefined, register a random number
    id = Math.floor(Math.random() * 1000000).toString();
  }

  toast(<WToast {...{ message, id, type }} />, {
    transition: 'zoom',
    delay: 50,
  });
}
